import { ReactNode } from 'react';
import {
  Container,
  useMediaQuery,
} from '@chakra-ui/react';

import {
  InfoPanel,
  BasePanel,
} from 'view-layer/components/layout';

interface ContainerProps {
  children?: ReactNode
  payment: any,
  withActions?: boolean,
}

export const LayoutContainer: React.FC<ContainerProps> = ({ children, payment, withActions = false }) => {
  const [ isDesktop ] = useMediaQuery('(min-width: 992px)');
  const variant = isDesktop ? 'rows' : 'columns';
  return (
    <Container maxW="960px" minHeight="500px" variant={variant}>
      <InfoPanel payment={payment} />
      <BasePanel payment={payment} withActions={withActions}>
        {children}
      </BasePanel>
    </Container>
  );
}
